export function LogoMark({ className = "h-11 w-11" }: { className?: string }) {
  return (
    <img
      src="/logo.png"
      alt="Tuft and Tale logo"
      width={512}
      height={512}
      className={`${className} shrink-0 rounded-xl`}
    />
  );
}

export function Brand({ dark = false }: { dark?: boolean }) {
  return (
    <span className="flex items-center" data-testid="brand-wordmark">
      <LogoMark className={dark ? "h-16 w-16" : "h-12 w-12 md:h-14 md:w-14"} />
    </span>
  );
}
